
































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { OrderColumn } from '@/models/reports/report-order-column';
import { SelectItem } from '@/models/reports/select-item';
import { SortDirection } from '@/models/reports/sort-direction';
import fieldSelector from '@/components/field-selector/field-selector.vue';
// @ts-ignore
import Draggable from 'vuedraggable';
import { FieldSelectorSelection } from '@/models/field-selector/field-selector-selection';
import { Field } from '@/models/reports/report-field';

@Component({
    components: {
        Draggable,
        fieldSelector,
    },
})
export default class ReportOrderColumns extends Vue {
    @Prop({ required: true }) public orderColumns!: Array<OrderColumn>;
    @Prop({ required: true }) public orderDirections!: Array<SelectItem>;
    @Prop() public selectedEntities!: Array<number | null | undefined>;

    private selectorOptions: FieldSelectorSelection;
    private showDisplayColumnFieldSelector: boolean = false;
    private selectedColumn: OrderColumn | null = null;
    private tempOrderColumns: Array<OrderColumn> = new Array<OrderColumn>();

    private get hasOrderColumns(): boolean {
        return this.tempOrderColumns.length > 0;
    }

    @Watch('orderColumns')
    private orderColumnsChange(orderColumns: Array<OrderColumn>) {
        this.tempOrderColumns = [ ...orderColumns ];
    }
    private removeOrderColumn(column: OrderColumn) {
        this.$emit('order-column-removed', column);
    }
    private addOrderColumn() {
        this.$emit('order-column-added');
    }
    private openFieldSelector(column: OrderColumn) {
        this.selectedColumn = column;
        this.showDisplayColumnFieldSelector = true;
        const results = new FieldSelectorSelection();

        results.SingleSelect = true;
        results.RestrictToEntityTypes = this.selectedEntities;

        if (column.field) {
            results.Selections.push(column.field);
        }

        this.selectorOptions = results;
    }

    private selectField(selections: Array<Field>): void {
        if (selections == null || selections.length === 0 || this.selectedColumn == null) {
            return;
        }

        this.selectedColumn.field = selections[0];
        this.selectedColumn = null;
        this.showDisplayColumnFieldSelector = false;
    }

    private cancelSelect() {
        this.showDisplayColumnFieldSelector = false;
        this.selectedColumn = null;
    }

    private handleReorder() {
        this.$emit('order-columns-reordered', this.tempOrderColumns);
    }
}
